import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type RiskIconProps = CommonSvgProps

const RiskIcon: React.FC<RiskIconProps> = React.forwardRef<SVGSVGElement, RiskIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 74 74" {...props} ref={ref} color="none">
      <path
        d="M37 71.1668C55.8697 71.1668 71.1666 55.8699 71.1666 37.0002C71.1666 18.1304 55.8697 2.8335 37 2.8335C18.1303 2.8335 2.83331 18.1304 2.83331 37.0002C2.83331 55.8699 18.1303 71.1668 37 71.1668Z"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 23.3335V37.0002"
        stroke="#53A2D9"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 50.6665H37.0329"
        stroke="#53A2D9"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
)

RiskIcon.propTypes = commonPropTypes
RiskIcon.defaultProps = commonDefaultProps

export default RiskIcon
